module.exports = __webpack_public_path__ + "fonts/jioicons--4befcf6a52dcd9c12af1b150818d38ef.4befcf6a52dcd9c12af1b150818d38ef.woff";